import gql from 'graphql-tag';
import { GROUP_TYPE, GROUP_TYPE_VALUES } from './GroupType.gql';

export const GROUP_TYPE_CONNECTION = gql`
  ${GROUP_TYPE}
  fragment GroupTypeConnection on GroupTypeConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...GroupType
      }
    }
    totalCount
    edgeCount
  }
`;

export const GROUP_TYPE_CONNECTION_VALUES = gql`
  ${GROUP_TYPE_VALUES}
  fragment GroupTypeConnection on GroupTypeConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...GroupType
      }
    }
    totalCount
    edgeCount
  }
`;
